module.exports = __webpack_public_path__ + "static/media/white_category_icon_c6.5de63d03.svg";